/** 客户管理API */
import type { Api } from '@/typings/api';
import { download, post, upload } from '../../request';
const prefix = '/base/customerInfo';
/**
 * 分页查询客户管理
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.Base.CustomerInfo> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询客户管理列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.Base.CustomerInfo> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个客户管理
 *
 * @param id 客户管理ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.Base.CustomerInfo> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存客户管理
 *
 * @param params 客户管理信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新客户管理信息
 *
 * @param params 客户管理信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除客户管理
 *
 * @param id 客户管理ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除客户管理
 *
 * @param ids 客户管理ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};

/**
 * 导出
 *
 * @param params
 * @returns
 */
export const doExport = (params: Api.Common.CommonSearchParams) => {
  return download(`${prefix}/export`, params);
};

/**
 * 导入
 *
 * @param file 文件
 * @param params
 * @returns
 */
export const doImport = (file: File, params: Api.Common.ImportParams = { isCustom: true }) => {
  return upload(`${prefix}/import`, file, params);
};

/**
 *
 * @param id customerId
 * @param upgradeSwitch 升级开关
 */
export const updateUpgradeSwitch = (params: any) => {
  return post(`${prefix}/updateUpgradeSwitch`, params);
};
/**
 *
 * @param customerIds
 * @param productIds
 */
export const batchAllotProduct = (params: { customerIds: string[]; productIds: string[] }) => {
  return post(`${prefix}/batchAllotProduct`, params);
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete,
  batchAllotProduct
};
